// @ts-strict-ignore
import { ApiData } from '../../models'

export const orNew = <T>(data: ApiData<T>) => data || new ApiData<T>()
export const asData = <T>(data: T) => new ApiData<T>().succeeded(data)
